import { EvidencePopup } from "../../../../components/pop-up/EvidencePopup";
import { OwnerPopup } from "../../../../components/pop-up/OwnerPopup";

import { useEffect, useState } from "react";
import {
  fetchAssetReferralById,
  createAssetEvidence,
  createAssetOwner,
  createAssetSuspect,
  createAssetReporter,
  fetchPersonsListBYFaydaIdOrPhoneNumber,
  addPerson,
  createAssetVictim,
  createAssetWitness,
  deleteAssetEvidence,
  deleteAssetOwner,
  deleteAssetReporter,
  deleteAssetSuspect,
  deleteAssetVictim,
  deleteAssetWitness,
  updateAssetOwner,
  updateAssetEvidence,
  updateAssetSuspect,
  updateAssetReporter,
  updateAssetVictim,
  updateAssetWitness,
} from "services/assetRecoveryService";
import { errorHandlerOnForm } from "utils/helper";
import { useTooltip } from "context/TooltipProvider";
import {
  Asset,
  EntityType,
  Person,
  Referral,
  SeizureRestraintRecord,
} from "types";
import { ReporterPopup } from "components/pop-up/ReporterPopup";
import { SuspectPopup } from "components/pop-up/SuspectPopup";
import { VictimPopup } from "components/pop-up/VictimPopup";
import { WitnessPopup } from "components/pop-up/WitnessPopup";
import FileViewer from "components/file-components/fileViewer2";
import UserDetailsPopup from "components/pop-up/UserDetailsPopup";
import EvidenceCard from "components/referralContent/EvidenceCard";
import OwnerCard from "components/referralContent/OwnerCard";
import ReporterCard from "components/referralContent/ReporterCard";
import SuspectCard from "components/referralContent/SuspectCard";
import VictimCard from "components/referralContent/VitimCard";
import WitnessCard from "components/referralContent/WitnesCard";
import AssetCard from "components/referralContent/AssetCard";
import AddReferralAssetPopup from "components/pop-up/AddReferralAssetPopup";
import SeizureRestraintForm from "pages/AssetRecovery/Assets/AddProvision";
import { AssetGovernancePopup } from "pages/AssetRecovery/Assets/AddAssetGovernance";
import AssetDetailsPopup from "components/pop-up/AssetDetailsPopup";
import AssetDetail from "pages/AssetRecovery/Assets/AssetDetail";
import { useTranslation } from "react-i18next";

const initialEvidenceFormData = {
  description: "",
  date: "",
  file: null as File | null | string,
  evidence_type: "",
  referral: "",
};

const initialOwnerFormData = {
  ownership_proof: null as File | null | string,
  property_description: "",
  referral: "",
  person_id: "",
  person: null as unknown as Person,
};

const initialSuspectFormData = {
  suspect_condition: "",
  court_appointment_date: "",
  final_verdict_amount: "",
  not_in_custody_reason: "",
  bail_information: "",
  court_registration_number: "",
  referral: "",
  court_bail_amount: "",
  court_bail_evidence: null as File | null,
  incident_registration_number: "",
  police_bail_amount: "",
  person_id: "",
  person: null as unknown as Person,
  police_bail_evidence: null as File | null,
};

const initialReporterFormData = {
  relationship_to_case: "",
  referral: "",
  person_id: "",
  person: null as unknown as Person,
};

const initialVictimFormData = {
  victim_type: "",
  victim_department: "",
  victim_name: "",
  victim_condition: "",
  referral: "",
  person_id: "",
  person: null as unknown as Person,
};

const initialWitnessFormData = {
  testimony_summary: "",
  referral: "",
  person_id: "",
  person: null as unknown as Person,
};

export default function AssetReferralContent({
  referralId,
  referralData,
  setReferralData,
  reports,
  recoveryReports,
  setActiveTab,
  handleAssetCreated,
}: {
  referralId: string | null;
  referralData: Referral | null;
  setReferralData?: React.Dispatch<React.SetStateAction<Referral | null>>;
  reports: any;
  recoveryReports: any;
  setActiveTab?: React.Dispatch<React.SetStateAction<string>>;
  handleAssetCreated: () => void;
}) {
  const [isEvidencePopupOpen, setIsEvidencePopupOpen] = useState(false);
  const [isAssetPopupOpen, setIsAssetPopupOpen] = useState(false);

  const [isOwnerPopupOpen, setIsOwnerPopupOpen] = useState(false);
  const [isSuspectPopupOpen, setIsSuspectPopupOpen] = useState(false);
  const [isReporterPopupOpen, setIsReporterPopupOpen] = useState(false);
  const [isVictimPopupOpen, setIsVictimPopupOpen] = useState(false);
  const [isWitnessPopupOpen, setIsWitnessPopupOpen] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  // const [referralData, setReferralData] = useState<Referral | null>(null);

  const [evidenceFormData, setEvidenceFormData] = useState(
    initialEvidenceFormData,
  );
  const [ownerFormData, setOwnerFormData] = useState(initialOwnerFormData);
  const [suspectFormData, setSuspectFormData] = useState(
    initialSuspectFormData,
  );
  const [reporterFormData, setReporterFormData] = useState(
    initialReporterFormData,
  );
  const [victimFormData, setVictimFormData] = useState(initialVictimFormData);
  const [witnessFormData, setWitnessFormData] = useState(
    initialWitnessFormData,
  );

  const [evidenceFile, setEvidenceFile] = useState<File[]>([]);
  const [ownerFile, setOwnerFile] = useState<File[]>([]);
  const [suspectFile, setSuspectFile] = useState<File[]>([]);
  const [courtBailFile, setCourtBailFile] = useState<File[]>([]);
  const [fileError, setFileError] = useState("");

  const [editingEntity, setEditingEntity] = useState<{
    type: "evidence" | "owner" | "suspect" | "reporter" | "victim" | "witness";
    id: string;
    data: any;
  } | null>(null);

  const [isEditMode, setIsEditMode] = useState(false);

  const { showTooltip } = useTooltip();
  const { t } = useTranslation();

  // State variables for person search
  const [searchFayda, setSearchFayda] = useState<string>("");
  const [searchPhone, setSearchPhone] = useState<string>("");
  const [searchedPersons, setSearchedPersons] = useState<Person[]>([]);
  const [selectedPerson, setSelectedPerson] = useState<Person | null>(null);
  const [selectedPersonId, setSelectedPersonId] = useState<string>("");
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const [userFormLoading, setUserFormLoading] = useState<boolean>(false);
  const [isFileViewerOpen, setIsFileViewerOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState<{
    name: string;
    size: number;
    url: string;
    isFetched: boolean;
    type: string;
    uuid: string;
  } | null>(null);
  const [isGovernancePopup, setIsGovernancePopup] = useState(false);
  const [isEditGovernanceMode, setIsEditGovernanceMode] = useState(false);
  const [selectedAssetForGovernance, setSelectedAssetForGovernance] =
    useState<Asset | null>(null);

  const [isProvisionPopupOpen, setIsProvisionPopupOpen] = useState(false);
  const [selectedAssetForProvision, setSelectedAssetForProvision] =
    useState<Asset | null>(null);
  const [isAssetDetailPopupOpen, setIsAssetDetailPopupOpen] = useState(false);
  const [selectedAssetForAssetDetail, setSelectedAssetForAssetDetail] =
    useState<Asset | null>(null);
  const handleAddGovernance = (asset: Asset) => {
    setSelectedAssetForGovernance(asset);
    setIsEditGovernanceMode(false);
    setIsGovernancePopup(true);
  };

  const handleEditGovernance = (asset: Asset) => {
    setSelectedAssetForGovernance(asset);
    setIsEditGovernanceMode(true);
    setIsGovernancePopup(true);
  };

  const handleAddProvision = (asset: Asset) => {
    setSelectedAssetForProvision(asset);
    setIsProvisionPopupOpen(true);
  };
  const handleOpenAssetDetail = (asset: Asset) => {
    setSelectedAssetForAssetDetail(asset);
    setIsAssetDetailPopupOpen(true);
  };
  const handleCloseGovernancePopup = () => {
    setIsGovernancePopup(false);
    setSelectedAssetForGovernance(null);
    setIsEditGovernanceMode(false);
  };

  const handleCloseProvisionPopup = () => {
    setIsProvisionPopupOpen(false);
    setSelectedAssetForProvision(null);
  };
  const handleCloseAssetDetailPopup = () => {
    setIsAssetDetailPopupOpen(false);
    setSelectedAssetForAssetDetail(null);
  };
  const handleGovernanceProvisionSuccess = async () => {
    const response = await fetchAssetReferralById(referralId as string);
    if (response) {
      setReferralData?.(response);
      showTooltip(
        t("operation_completed_successfully", {
          defaultValue: "Operation completed successfully!",
        }),
        "success",
      );
      setActiveTab?.("Assets");
    }
  };
  useEffect(() => {
    if (referralId) {
      setLoading(true);
      fetchAssetReferralById(referralId)
        .then((data) => {
          setReferralData?.(data);
          setLoading(false);
        })
        .catch(() => {
          showTooltip(
            t("failed_to_fetch_referral_data", {
              defaultValue: "Failed to fetch referral data",
            }),
            "error",
          );
          setLoading(false);
        });
    }
  }, [referralId]);

  // Update form data with referral ID when it becomes available
  useEffect(() => {
    if (referralId) {
      setEvidenceFormData((prev) => ({ ...prev, referral: referralId }));
      setOwnerFormData((prev) => ({ ...prev, referral: referralId }));
      setSuspectFormData((prev) => ({ ...prev, referral: referralId }));
      setReporterFormData((prev) => ({ ...prev, referral: referralId }));
      setVictimFormData((prev) => ({ ...prev, referral: referralId }));
      setWitnessFormData((prev) => ({ ...prev, referral: referralId }));
    }
  }, [referralId]);

  const [isUserDetailsOpen, setIsUserDetailsOpen] = useState(false);

  const fileRowProps = {
    fileViewerNumber: 2,
    setFileViewer2: setIsFileViewerOpen,
    setSelectedApplicantDocument: (document: any) => {
      setSelectedDocument(document);
      setIsFileViewerOpen(true);
      setIsUserDetailsOpen(false);
    },
    // setIsUserDetailsOpen:setIsUserDetailsOpen(false)
  };
  const [selectedUser, setSelectedUser] = useState<{
    person: Person;
    title: string;
    description: string;
    children?: React.ReactNode;
  } | null>(null);

  // Function to handle user view
  const handleUserView = (
    user: any,
    title: string,
    description: string,
    children?: React.ReactNode,
  ) => {
    setSelectedUser({
      person: user,
      title,
      description,
      children,
    });
    setIsUserDetailsOpen(true);
  };
  const handleClosePopup = () => {
    setIsEvidencePopupOpen(false);
    setIsOwnerPopupOpen(false);
    setIsSuspectPopupOpen(false);
    setIsReporterPopupOpen(false);
    setIsVictimPopupOpen(false);
    setIsWitnessPopupOpen(false);
    setIsAssetPopupOpen(false);
    setError(null);
    setEvidenceFile([]);
    setOwnerFile([]);
    setCourtBailFile([]);
    setFileError("");
    setSelectedPerson(null);
    setSearchedPersons([]);
    setEditingEntity(null);
    setIsEditMode(false);
  };
  const handleEdit = (entityType: EntityType, entityData: any) => {
    setEditingEntity({
      type: entityType,
      id: entityData.id,
      data: entityData,
    });
    setIsEditMode(true);

    // Pre-fill the form with existing data based on entity type
    switch (entityType) {
      case "owner":
        setOwnerFormData({
          property_description: entityData.property_description || "",
          referral: referralId || "",
          person_id: entityData.person?.id || "",
          ownership_proof: entityData?.ownership_proof || "",
          person: entityData?.person || null,
        });
        setSelectedPerson(entityData.person);
        setSelectedPersonId(entityData.person?.id || "");
        setIsOwnerPopupOpen(true);
        break;

      case "suspect":
        setSuspectFormData({
          suspect_condition: entityData.suspect_condition || "",
          court_appointment_date: entityData.court_appointment_date || "",
          final_verdict_amount: entityData.final_verdict_amount || "",
          not_in_custody_reason: entityData.not_in_custody_reason || "",
          bail_information: entityData.bail_information || "",
          court_registration_number: entityData.court_registration_number || "",
          referral: referralId || "",
          court_bail_amount: entityData.court_bail_amount || "",
          incident_registration_number:
            entityData.incident_registration_number || "",
          police_bail_amount: entityData.police_bail_amount || "",
          person_id: entityData.person?.id || "",
          court_bail_evidence: entityData?.court_bail_evidence || "",
          person: entityData?.person || null,
          police_bail_evidence: entityData?.police_bail_evidence || null,
        });
        setSelectedPerson(entityData.person);
        setSelectedPersonId(entityData.person?.id || "");
        setIsSuspectPopupOpen(true);
        break;

      case "reporter":
        setReporterFormData({
          relationship_to_case: entityData.relationship_to_case || "",
          referral: referralId || "",
          person_id: entityData.person?.id || "",
          person: entityData?.person || null,
        });
        setSelectedPerson(entityData.person);
        setSelectedPersonId(entityData.person?.id || "");
        setIsReporterPopupOpen(true);
        break;

      case "victim":
        setVictimFormData({
          victim_type: entityData.victim_type || "",
          victim_department: entityData.victim_department || "",
          victim_name: entityData.victim_name || "",
          victim_condition: entityData.victim_condition || "",
          referral: referralId || "",
          person_id: entityData.person?.id || "",
          person: entityData?.person || null,
        });
        setSelectedPerson(entityData.person);
        setSelectedPersonId(entityData.person?.id || "");
        setIsVictimPopupOpen(true);
        break;

      case "witness":
        setWitnessFormData({
          testimony_summary: entityData.testimony_summary || "",
          referral: referralId || "",
          person_id: entityData.person?.id || "",
          person: entityData?.person || null,
        });
        setSelectedPerson(entityData.person);
        setSelectedPersonId(entityData.person?.id || "");
        setIsWitnessPopupOpen(true);
        break;

      case "evidence":
        setEvidenceFormData({
          description: entityData.description || "",
          date: entityData.date || "",
          evidence_type: entityData.evidence_type || "",
          referral: referralId || "",
          file: entityData.file || null,
        });
        setIsEvidencePopupOpen(true);
        break;
    }
  };

  const handleButtonClick = (buttonType: EntityType) => {
    if (!referralId) {
      showTooltip(
        t("please_save_referral_first", {
          defaultValue: "Please save the referral first to add details.",
        }),
        "error",
      );
      return;
    }

    switch (buttonType) {
      case "evidence":
        setIsEvidencePopupOpen(true);
        break;
      case "owner":
        setIsOwnerPopupOpen(true);
        break;
      case "suspect":
        setIsSuspectPopupOpen(true);
        break;
      case "reporter":
        setIsReporterPopupOpen(true);
        break;
      case "victim":
        setIsVictimPopupOpen(true);
        break;
      case "witness":
        setIsWitnessPopupOpen(true);
        break;
    }
  };

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >,
    formType:
      | "evidence"
      | "owner"
      | "suspect"
      | "reporter"
      | "victim"
      | "witness",
  ) => {
    const { name, value } = e.target;

    switch (formType) {
      case "evidence":
        setEvidenceFormData((prev) => ({ ...prev, [name]: value }));
        break;
      case "owner":
        setOwnerFormData((prev) => ({ ...prev, [name]: value }));
        break;
      case "suspect":
        setSuspectFormData((prev) => ({ ...prev, [name]: value }));
        break;
      case "reporter":
        setReporterFormData((prev) => ({ ...prev, [name]: value }));
        break;
      case "victim":
        setVictimFormData((prev) => ({ ...prev, [name]: value }));
        break;
      case "witness":
        setWitnessFormData((prev) => ({ ...prev, [name]: value }));
        break;
    }
  };

  const handleSubmit = (
    e: React.FormEvent,
    formType:
      | "evidence"
      | "owner"
      | "suspect"
      | "reporter"
      | "victim"
      | "witness",
  ) => {
    e.preventDefault();
    setLoading(true);

    let apiCall: Promise<any>;
    let resetForm: (() => void) | undefined;

    switch (formType) {
      case "evidence":
        const formData = new FormData();

        if (evidenceFile.length > 0) {
          evidenceFile.forEach((file, index) => {
            formData.append(`evidence_file`, file);
          });
        }
        formData.append("description", evidenceFormData.description || "");
        formData.append("referral", evidenceFormData.referral || "");
        formData.append("date", evidenceFormData.date || "");
        formData.append("evidence_type", evidenceFormData.evidence_type || "");

        if (isEditMode && editingEntity?.type === "evidence") {
          apiCall = updateAssetEvidence(editingEntity.id, formData);
        } else {
          apiCall = createAssetEvidence(formData);
        }

        resetForm = () => {
          setEvidenceFormData({
            ...initialEvidenceFormData,
            referral: referralId || "",
          });
          setEvidenceFile([]);
        };
        break;

      case "owner":
        const formData2 = new FormData();
        ownerFormData.person_id = selectedPerson?.id as string;

        if (ownerFile.length > 0) {
          ownerFile.forEach((file, index) => {
            formData2.append(`ownership_proof`, file);
          });
        }

        formData2.append(
          "property_description",
          ownerFormData.property_description || "",
        );
        formData2.append("referral", ownerFormData.referral || "");
        formData2.append("person_id", ownerFormData.person_id || "");

        if (isEditMode && editingEntity?.type === "owner") {
          apiCall = updateAssetOwner(editingEntity.id, formData2);
        } else {
          formData2.append("person", JSON.stringify(selectedPerson || {}));
          apiCall = createAssetOwner(formData2);
        }

        resetForm = () => {
          setOwnerFormData({
            ...initialOwnerFormData,
            referral: referralId || "",
          });
          setOwnerFile([]);
        };
        break;

      case "suspect":
        const suspectDataWithPerson = {
          ...suspectFormData,
          person_id: selectedPerson?.id,
          person: selectedPerson,
        };

        const suspectFormDataWithFiles = new FormData();
        Object.keys(suspectDataWithPerson).forEach((key) => {
          if (key !== "police_bail_evidence" && key !== "court_bail_evidence") {
            suspectFormDataWithFiles.append(
              key,
              (suspectDataWithPerson as any)[key],
            );
          }
        });

        if (suspectFile.length > 0) {
          suspectFile.forEach((file, index) => {
            suspectFormDataWithFiles.append("police_bail_evidence", file);
          });
        }
        if (courtBailFile.length > 0) {
          courtBailFile.forEach((file, index) => {
            suspectFormDataWithFiles.append("court_bail_evidence", file);
          });
        }

        if (isEditMode && editingEntity?.type === "suspect") {
          apiCall = updateAssetSuspect(
            editingEntity.id,
            suspectFormDataWithFiles,
          );
        } else {
          apiCall = createAssetSuspect(suspectFormDataWithFiles);
        }

        resetForm = () => {
          setSuspectFormData({
            ...initialSuspectFormData,
            referral: referralId || "",
          });
          setSuspectFile([]);
          setCourtBailFile([]);
        };
        break;

      case "reporter":
        const reporterDataWithPerson = {
          ...reporterFormData,
          person_id: selectedPerson?.id,
          person: selectedPerson,
        };

        if (isEditMode && editingEntity?.type === "reporter") {
          apiCall = updateAssetReporter(
            editingEntity.id,
            reporterDataWithPerson,
          );
        } else {
          apiCall = createAssetReporter(reporterDataWithPerson);
        }

        resetForm = () => {
          setReporterFormData({
            ...initialReporterFormData,
            referral: referralId || "",
          });
        };
        break;

      case "victim":
        const victimDataWithPerson = {
          ...victimFormData,
          person_id: selectedPerson?.id,
          person: selectedPerson,
        };

        if (isEditMode && editingEntity?.type === "victim") {
          apiCall = updateAssetVictim(editingEntity.id, victimDataWithPerson);
        } else {
          apiCall = createAssetVictim(victimDataWithPerson);
        }

        resetForm = () => {
          setVictimFormData({
            ...initialVictimFormData,
            referral: referralId || "",
          });
        };
        break;

      case "witness":
        const witnessDataWithPerson = {
          ...witnessFormData,
          person_id: selectedPerson?.id,
          person: selectedPerson,
        };

        if (isEditMode && editingEntity?.type === "witness") {
          apiCall = updateAssetWitness(editingEntity.id, witnessDataWithPerson);
        } else {
          apiCall = createAssetWitness(witnessDataWithPerson);
        }

        resetForm = () => {
          setWitnessFormData({
            ...initialWitnessFormData,
            referral: referralId || "",
          });
        };
        break;

      default:
        showTooltip(
          t("unknown_form_type", { defaultValue: "Unknown form type" }),
          "error",
        );
        setLoading(false);
        return;
    }

    apiCall
      .then(() => {
        const action = isEditMode ? "Updated" : "Submitted";
        showTooltip(`Successfully ${action}!`, "success");
        resetForm?.();
        handleClosePopup();

        // Reset edit mode
        setEditingEntity(null);
        setIsEditMode(false);

        // Refresh referral data
        if (referralId) {
          fetchAssetReferralById(referralId)
            .then((data) => setReferralData?.(data))
            .catch(() =>
              showTooltip(t("failed_to_refresh_referral_data"), "error"),
            );
        }
      })
      .catch((err) => {
        showTooltip(errorHandlerOnForm(err?.response?.data), "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = (id: string, entityType: EntityType) => {
    setLoading(true);

    let apiCall: Promise<any>;

    switch (entityType) {
      case "evidence":
        apiCall = deleteAssetEvidence(id);
        break;
      case "owner":
        apiCall = deleteAssetOwner(id);
        break;
      case "suspect":
        apiCall = deleteAssetSuspect(id);
        break;
      case "reporter":
        apiCall = deleteAssetReporter(id);
        break;
      case "victim":
        apiCall = deleteAssetVictim(id);
        break;
      case "witness":
        apiCall = deleteAssetWitness(id);
        break;
      default:
        showTooltip(
          t("unknown_entity_type", { defaultValue: "Unknown entity type" }),
          "error",
        );
        setLoading(false);
        return;
    }

    apiCall
      .then(() => {
        showTooltip(t("successfully_deleted"), "success");
        if (referralId) {
          fetchAssetReferralById(referralId)
            .then((data) => setReferralData?.(data))
            .catch(() =>
              showTooltip(t("failed_to_refresh_referral_data"), "error"),
            );
        }
      })
      .catch((err) => {
        showTooltip(errorHandlerOnForm(err?.response?.data), "error");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSearchPerson = async (e: React.FormEvent) => {
    e.preventDefault();
    setSearchLoading(true);

    try {
      const searchParams: { faydaId?: string; phoneNumber?: string } = {};
      if (searchFayda) searchParams.faydaId = searchFayda;
      if (searchPhone) searchParams.phoneNumber = searchPhone;

      const persons =
        await fetchPersonsListBYFaydaIdOrPhoneNumber(searchParams);
      setSearchedPersons(persons);

      if (persons.length === 1) {
        setSelectedPerson(persons[0]);
        setSelectedPersonId(persons[0].id_number);
      } else {
        setSelectedPerson(null);
        setSelectedPersonId("");
      }
    } catch (error) {
      console.error("Search failed:", error);
      setSearchedPersons([]);
      setSelectedPerson(null);
      setSelectedPersonId("");
    } finally {
      setSearchLoading(false);
    }
  };

  const handlePersonSelect = (personId: string) => {
    setSelectedPersonId(personId);
    const person = searchedPersons.find((p) => p.id_number === personId);
    setSelectedPerson(person || null);
  };

  const handleUserSubmit = async (data: Person, isEditMode: boolean) => {
    setUserFormLoading(true);
    try {
      if (isEditMode) {
        const searchParams: { faydaId?: string; phoneNumber?: string } = {};
        if (searchFayda) searchParams.faydaId = searchFayda;
        if (searchPhone) searchParams.phoneNumber = searchPhone;
        const updatedPersons =
          await fetchPersonsListBYFaydaIdOrPhoneNumber(searchParams);
        setSearchedPersons(updatedPersons);
      } else {
        const response = await addPerson(data);
        data.id = response.asset_person_id;
        setSelectedPerson(data);
        setSelectedPersonId(response.asset_person_id);
        setSearchedPersons([data]);
      }
    } catch (error) {
      console.error("User operation failed:", error);
    } finally {
      setUserFormLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">Loading...</div>
    );
  }

  return (
    <>
      <div className="referral-details-container">
        <AssetCard
          fileRowProps={fileRowProps}
          handleAssetCreated={handleAssetCreated}
          recoveryReports={recoveryReports}
          reports={reports}
          setActiveTab={setActiveTab}
          handleButtonClick={handleButtonClick}
          handleEdit={handleEdit}
          referralData={referralData}
          referralId={referralId as string}
          onAddGovernance={handleAddGovernance}
          onEditGovernance={handleEditGovernance}
          onAddProvision={handleAddProvision}
          setIsAssetPopupOpen={setIsAssetPopupOpen}
          handleOpenAssetDetail={handleOpenAssetDetail}
        />
        <EvidenceCard
          referralData={referralData}
          referralId={referralId as string}
          handleButtonClick={handleButtonClick}
          handleEdit={handleEdit}
          fileRowProps={fileRowProps}
        />

        <OwnerCard
          referralData={referralData}
          referralId={referralId as string}
          handleButtonClick={handleButtonClick}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleUserView={handleUserView}
          fileRowProps={fileRowProps}
        />

        <SuspectCard
          referralData={referralData}
          referralId={referralId as string}
          handleButtonClick={handleButtonClick}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleUserView={handleUserView}
          fileRowProps={fileRowProps}
        />

        <ReporterCard
          referralData={referralData}
          referralId={referralId as string}
          handleButtonClick={handleButtonClick}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleUserView={handleUserView}
        />

        <VictimCard
          referralData={referralData}
          referralId={referralId as string}
          handleButtonClick={handleButtonClick}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleUserView={handleUserView}
        />

        <WitnessCard
          referralData={referralData}
          referralId={referralId as string}
          handleButtonClick={handleButtonClick}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
          handleUserView={handleUserView}
        />
      </div>

      <AddReferralAssetPopup
        handleAssetCreated={handleAssetCreated}
        id={referralId as string}
        isOpen={isAssetPopupOpen}
        onClose={handleClosePopup}
        referralData={referralData as Referral}
        setActiveTab={setActiveTab}
      />
      <EvidencePopup
        isOpen={isEvidencePopupOpen}
        onClose={handleClosePopup}
        onSubmit={(e) => handleSubmit(e, "evidence")}
        onInputChange={(e) => handleInputChange(e, "evidence")}
        onFileChange={setEvidenceFile}
        formData={evidenceFormData}
        pdfFile={evidenceFile}
        loading={loading}
        error={error}
        isEditMode={isEditMode}
        existingData={
          editingEntity?.type === "evidence" ? editingEntity.data : null
        }
      />

      <OwnerPopup
        isOpen={isOwnerPopupOpen}
        onClose={handleClosePopup}
        onSubmit={(e) => handleSubmit(e, "owner")}
        onInputChange={(e) => handleInputChange(e, "owner")}
        onFileChange={setOwnerFile}
        onSearchPerson={handleSearchPerson}
        onPersonSelect={handlePersonSelect}
        onUserSubmit={handleUserSubmit}
        formData={ownerFormData}
        pdfFile={ownerFile}
        loading={loading}
        error={error}
        searchFayda={searchFayda}
        setSearchFayda={setSearchFayda}
        searchPhone={searchPhone}
        setSearchPhone={setSearchPhone}
        searchedPersons={searchedPersons}
        selectedPerson={selectedPerson}
        selectedPersonId={selectedPersonId}
        searchLoading={searchLoading}
        userFormLoading={userFormLoading}
        isEditMode={isEditMode}
        existingData={
          editingEntity?.type === "owner" ? editingEntity.data : null
        }
        setSelectedPerson={setSelectedPerson}
        setSelectedPersonId={setSelectedPersonId}
        setSearchedPersons={setSearchedPersons}
      />

      <SuspectPopup
        isOpen={isSuspectPopupOpen}
        onClose={handleClosePopup}
        onSubmit={(e) => handleSubmit(e, "suspect")}
        onInputChange={(e) => handleInputChange(e, "suspect")}
        onSearchPerson={handleSearchPerson}
        onPersonSelect={handlePersonSelect}
        onUserSubmit={handleUserSubmit}
        setCourtBailFile={setCourtBailFile}
        setPoliceBailFile={setSuspectFile}
        formData={suspectFormData}
        loading={loading}
        error={error}
        searchFayda={searchFayda}
        setSearchFayda={setSearchFayda}
        searchPhone={searchPhone}
        setSearchPhone={setSearchPhone}
        searchedPersons={searchedPersons}
        selectedPerson={selectedPerson}
        selectedPersonId={selectedPersonId}
        searchLoading={searchLoading}
        userFormLoading={userFormLoading}
        suspectFile={suspectFile}
        courtBailFile={courtBailFile}
        fileError={fileError}
        isEditMode={isEditMode}
        existingData={
          editingEntity?.type === "suspect" ? editingEntity.data : null
        }
        setSelectedPerson={setSelectedPerson}
        setSelectedPersonId={setSelectedPersonId}
        setSearchedPersons={setSearchedPersons}
      />

      <ReporterPopup
        isOpen={isReporterPopupOpen}
        onClose={handleClosePopup}
        onSubmit={(e) => handleSubmit(e, "reporter")}
        onInputChange={(e) => handleInputChange(e, "reporter")}
        onSearchPerson={handleSearchPerson}
        onPersonSelect={handlePersonSelect}
        onUserSubmit={handleUserSubmit}
        formData={reporterFormData}
        loading={loading}
        error={error}
        searchFayda={searchFayda}
        setSearchFayda={setSearchFayda}
        searchPhone={searchPhone}
        setSearchPhone={setSearchPhone}
        searchedPersons={searchedPersons}
        selectedPerson={selectedPerson}
        selectedPersonId={selectedPersonId}
        searchLoading={searchLoading}
        userFormLoading={userFormLoading}
        isEditMode={isEditMode}
        existingData={
          editingEntity?.type === "reporter" ? editingEntity.data : null
        }
        setSelectedPerson={setSelectedPerson}
        setSelectedPersonId={setSelectedPersonId}
        setSearchedPersons={setSearchedPersons}
      />

      <VictimPopup
        isOpen={isVictimPopupOpen}
        onClose={handleClosePopup}
        onSubmit={(e) => handleSubmit(e, "victim")}
        onInputChange={(e) => handleInputChange(e, "victim")}
        onSearchPerson={handleSearchPerson}
        onPersonSelect={handlePersonSelect}
        onUserSubmit={handleUserSubmit}
        formData={victimFormData}
        loading={loading}
        error={error}
        searchFayda={searchFayda}
        setSearchFayda={setSearchFayda}
        searchPhone={searchPhone}
        setSearchPhone={setSearchPhone}
        searchedPersons={searchedPersons}
        selectedPerson={selectedPerson}
        selectedPersonId={selectedPersonId}
        searchLoading={searchLoading}
        userFormLoading={userFormLoading}
        isEditMode={isEditMode}
        existingData={
          editingEntity?.type === "victim" ? editingEntity.data : null
        }
        setSelectedPerson={setSelectedPerson}
        setSelectedPersonId={setSelectedPersonId}
        setSearchedPersons={setSearchedPersons}
      />

      <WitnessPopup
        isOpen={isWitnessPopupOpen}
        onClose={handleClosePopup}
        onSubmit={(e) => handleSubmit(e, "witness")}
        onInputChange={(e) => handleInputChange(e, "witness")}
        onSearchPerson={handleSearchPerson}
        onPersonSelect={handlePersonSelect}
        onUserSubmit={handleUserSubmit}
        formData={witnessFormData}
        loading={loading}
        error={error}
        searchFayda={searchFayda}
        setSearchFayda={setSearchFayda}
        searchPhone={searchPhone}
        setSearchPhone={setSearchPhone}
        searchedPersons={searchedPersons}
        selectedPerson={selectedPerson}
        selectedPersonId={selectedPersonId}
        searchLoading={searchLoading}
        userFormLoading={userFormLoading}
        isEditMode={isEditMode}
        existingData={
          editingEntity?.type === "witness" ? editingEntity.data : null
        }
        setSelectedPerson={setSelectedPerson}
        setSelectedPersonId={setSelectedPersonId}
        setSearchedPersons={setSearchedPersons}
      />
      <FileViewer
        selectedApplicantDocument={selectedDocument || undefined}
        isPopupOpen={isFileViewerOpen}
        setIsPopupOpen={setIsFileViewerOpen}
      />
      <UserDetailsPopup
        showDetail={isUserDetailsOpen}
        setShowDetail={setIsUserDetailsOpen}
        person={selectedUser?.person as Person}
        title={selectedUser?.title as string}
        decription={selectedUser?.description as string}
        children={selectedUser?.children}
      />
      {selectedAssetForGovernance && (
        <AssetGovernancePopup
          isOpen={isGovernancePopup}
          onClose={handleCloseGovernancePopup}
          assetId={selectedAssetForGovernance.id as string}
          isEditMode={isEditGovernanceMode}
          existingData={
            isEditGovernanceMode
              ? {
                  agrement: null,
                  authorizing_body:
                    selectedAssetForGovernance?.authorizing_body,
                  governing_body: selectedAssetForGovernance?.governing_body,
                  governing_body_contact:
                    selectedAssetForGovernance?.governing_body_contact,
                  governing_body_house_number:
                    selectedAssetForGovernance?.governing_body_house_number,
                  governing_body_region:
                    selectedAssetForGovernance?.governing_body_region,
                  governing_body_town:
                    selectedAssetForGovernance?.governing_body_town,
                  governing_body_woreda:
                    selectedAssetForGovernance?.governing_body_woreda,
                  governing_body_zone:
                    selectedAssetForGovernance?.governing_body_zone,
                  governing_duration_end_date:
                    selectedAssetForGovernance?.governing_duration_end_date,
                  governing_duration_start_date:
                    selectedAssetForGovernance?.governing_duration_start_date,
                  reason_for_governing:
                    selectedAssetForGovernance?.reason_for_governing,
                }
              : undefined
          }
          onSuccess={handleGovernanceProvisionSuccess}
        />
      )}

      {/* New Provision Popup */}
      {selectedAssetForProvision && (
        <SeizureRestraintForm
          asset={selectedAssetForProvision}
          isOpen={isProvisionPopupOpen}
          mode="create"
          onClose={handleCloseProvisionPopup}
          onSuccess={handleGovernanceProvisionSuccess}
          referralId={referralId as string}
          setActiveTab={setActiveTab}
        />
      )}
      {/* {selectedAssetForAssetDetail && (
        <AssetDetailsPopup
          asset={selectedAssetForAssetDetail}
          title="Asset Details"
          description=""
          showDetail={isAssetDetailPopupOpen}
          setShowDetail={setIsAssetDetailPopupOpen}
        />
      )} */}
      {selectedAssetForAssetDetail && (
        <AssetDetail
          action_status=""
          fileRowProps={fileRowProps}
          onDelete={() => {}}
          onEdit={() => {}}
          records={
            selectedAssetForAssetDetail.seizure_restrain_records as SeizureRestraintRecord[]
          }
          asset={selectedAssetForAssetDetail}
          title="Asset Details"
          description=""
          showDetail={isAssetDetailPopupOpen}
          setShowDetail={setIsAssetDetailPopupOpen}
          onAddGovernance={() => {
            setIsAssetDetailPopupOpen(false);
            handleAddGovernance(selectedAssetForAssetDetail);
          }}
          onAddProvision={() => {
            setIsAssetDetailPopupOpen(false);
            handleAddProvision(selectedAssetForAssetDetail);
          }}
          onEditGovernance={() => {
            setIsAssetDetailPopupOpen(false);

            handleEditGovernance(selectedAssetForAssetDetail);
          }}
          onAssetCreated={handleAssetCreated}
        />
      )}
    </>
  );
}
